import CloseButton from "../assets/images/close.svg"
import S3Logo from "../assets/images/aws-s3.svg"
import AzureBlobStore from "../assets/images/azure-blob-store.svg"
import GoogleObjStore from "../assets/images/gcp-obj-store.svg"
import FlowChart1 from "../assets/images/flow-chart-1.png"
import Error from '../assets/images/error.png'
import KriusLogo from '../assets/images/kriusLogo.svg'
import MinioLogo from '../assets/images/MINIO_wordmark.png'
import SettingsGear from '../assets/images/settings-gear.png'
import Prometheus from '../assets/images/prometheus.png'
import Thanos from '../assets/images/thanos.png'
import HelpIcon from "../assets/images/help_outline_black.svg"

const images = {
    CloseButton,
    S3Logo,
    AzureBlobStore,
    FlowChart1,
    Error,
    KriusLogo,
    GoogleObjStore,
    MinioLogo,
    SettingsGear,
    Prometheus,
    Thanos,
    HelpIcon
}
export default images